import { css } from "lit";

export const alertItemStyles = css`
  :host {
    display: block;
  }

  .alert {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 16px;
    border-radius: var(--sds-size-radius-400);
    background: var(--sds-color-background-default-default);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    box-shadow: 0 4px 12px rgb(0 0 0 / 0.1);
    min-height: 48px;
  }

  .alert-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  }

  .alert-success .alert-icon {
    color: var(--sds-color-icon-positive-default);
  }

  .alert-warning .alert-icon {
    color: var(--sds-color-icon-warning-default);
  }

  .alert-error .alert-icon {
    color: var(--sds-color-icon-danger-default);
  }

  .alert-info .alert-icon {
    color: #0a84ff;
  }

  .alert-divider {
    width: 1px;
    height: 24px;
    background: var(--sds-color-border-default-default);
    flex-shrink: 0;
  }

  .alert-content {
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .alert-message {
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1;
    color: var(--sds-color-text-default-default);
    overflow-wrap: break-word;
  }
`;
